/**
 * A settings section with a nav entry and a page, but no feature behind it
 * yet — the navigation framework is built now, the feature later.
 *
 * Deliberately not a fake form: a placeholder with disabled-looking inputs
 * invites someone to wonder why saving does nothing. Saying plainly that it
 * is coming, with what it will eventually do, is the honest version of the
 * same empty state.
 */

import type { LucideIcon } from 'lucide-react';

export default function PlaceholderSection({
  icon: Icon,
  title,
  description,
}: {
  icon: LucideIcon;
  title: string;
  description: string;
}) {
  return (
    <div className="flex min-h-[360px] flex-col items-center justify-center rounded-xl border border-dashed border-slate-200 bg-slate-50/60 px-8 py-16 text-center">
      <div className="flex h-12 w-12 items-center justify-center rounded-full bg-white shadow-sm ring-1 ring-slate-200">
        <Icon className="h-5 w-5 text-slate-400" />
      </div>
      <h3 className="mt-4 text-sm font-semibold text-slate-700">{title}</h3>
      <p className="mt-1.5 max-w-sm text-[12.5px] leading-relaxed text-slate-500">{description}</p>
      <span className="mt-4 rounded-full bg-slate-200/80 px-3 py-1 text-[10.5px] font-semibold uppercase tracking-wide text-slate-500">
        Coming soon
      </span>
    </div>
  );
}
